import React from 'react';
// template
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import familyOnCouch from  '../../../../../images/components/experienceCalloutImages/family-on-couch.webp';
// styles
import { ExperienceCalloutStyled } from './styles';

export default () => (
  <ExperienceCalloutStyled
    moduleName='quiz-callout-module'
    moduleVariation='A'
    sectionId='quiz-callout-term-life-insurance'
    assistiveText='Get started with our Life Insurance quiz'
    backgroundVariant='lightA'
    buttonText='Take our quiz'
    calloutBackgroundVariant='lightC'
    withBGImage
    withHoverShadow={false}
    calloutThemeType='lightTheme'
    themeType='lightTheme'
    headingText={<>How much do you know about <WidowBlock>life insurance&#63;</WidowBlock></>}
    isFullWidth
    imageUrl={familyOnCouch.toString()}
    linkUrl='/life-and-money/quiz/life-insurance-quiz-how-much-do-you-know/'
    disableLazyLoad
  />
);
